import React, { useState, useEffect } from 'react';
import { useGame } from '../context/GameContext';

function VictoryScreen({ onRestart, onContinue }) {
  const { stats, kingdomTier, totalBuildings, researchedTechs } = useGame();
  const [showCredits, setShowCredits] = useState(false);

  // Format play time
  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    if (hrs > 0) {
      return `${hrs}h ${mins}m ${secs}s`;
    } else if (mins > 0) {
      return `${mins}m ${secs}s`;
    }
    return `${secs}s`;
  };

  // Download save file
  const downloadSave = () => {
    const saveData = localStorage.getItem('medievalKingdomSave');
    if (saveData) {
      const blob = new Blob([saveData], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `realm-of-ages-victory-${Date.now()}.json`;
      a.click();
      URL.revokeObjectURL(url);
    }
  };

  return (
    <div className="victory-screen">
      <div className="victory-container">
        {/* Beacon Animation */}
        <div className="victory-beacon">
          <div className="beacon-glow"></div>
          <div className="beacon-icon">🌌</div>
          <div className="beacon-rays">
            {[...Array(8)].map((_, i) => (
              <div key={i} className="ray" style={{ transform: `rotate(${i * 45}deg)` }}></div>
            ))}
          </div>
        </div>

        <h1 className="victory-title">VICTORY</h1>
        <p className="victory-subtitle">The Dimensional Beacon Activates</p>

        <div className="victory-story">
          <p>
            The massive crystal structure hums with otherworldly energy. Colors you've never 
            seen dance across its surface as reality itself begins to bend. A portal tears 
            open in the sky — not to darkness, but to light. <em>Your</em> light. <em>Your</em> home.
          </p>
          <p>
            After all these ages building, researching, and ascending through the eras... 
            the path home finally opens before you.
          </p>
          <p className="victory-final">
            👑 You have reclaimed your destiny, Exiled Ruler. 👑
          </p>
        </div>

        {/* Stats Summary */}
        <div className="victory-stats">
          <h3>Your Journey</h3>
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-icon">⏱️</span>
              <span className="stat-label">Time Played</span>
              <span className="stat-value">{formatTime(stats.playTime)}</span>
            </div>
            <div className="stat-item">
              <span className="stat-icon">🏗️</span>
              <span className="stat-label">Buildings Built</span>
              <span className="stat-value">{totalBuildings}</span>
            </div>
            <div className="stat-item">
              <span className="stat-icon">🔬</span>
              <span className="stat-label">Technologies</span>
              <span className="stat-value">{researchedTechs.length}</span>
            </div>
            <div className="stat-item">
              <span className="stat-icon">👆</span>
              <span className="stat-label">Total Clicks</span>
              <span className="stat-value">{stats.totalClicks.toLocaleString()}</span>
            </div>
            <div className="stat-item">
              <span className="stat-icon">🏰</span>
              <span className="stat-label">Kingdom Tier</span>
              <span className="stat-value">Tier {kingdomTier}</span>
            </div>
            <div className="stat-item">
              <span className="stat-icon">👑</span>
              <span className="stat-label">Advisors Hired</span>
              <span className="stat-value">{stats.advisorsHired}</span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="victory-actions">
          <button className="victory-btn save" onClick={downloadSave}>
            💾 Download Victory Save
          </button>
          <button className="victory-btn continue" onClick={onContinue}>
            ▶️ Continue Playing
          </button>
          <button className="victory-btn restart" onClick={onRestart}>
            🔄 New Game
          </button>
        </div>

        <div className="victory-footer">
          <p>Thank you for playing Realm of Ages</p>
          <p className="footer-sub">A game about patience, progress, and the journey home</p>
        </div>
      </div>

      {/* Background Effects */}
      <div className="victory-bg">
        <div className="star vs-1">✦</div>
        <div className="star vs-2">✧</div>
        <div className="star vs-3">⚝</div>
        <div className="star vs-4">✦</div>
        <div className="star vs-5">✧</div>
        <div className="star vs-6">✦</div>
        <div className="portal-ring ring-1"></div>
        <div className="portal-ring ring-2"></div>
        <div className="portal-ring ring-3"></div>
      </div>
    </div>
  );
}

export default VictoryScreen;
